module.exports = __webpack_public_path__ + "static/media/14.fa90447b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/14.jpg
// module id = 704
// module chunks = 0